import { HttpService } from '../../services/HttpService';
import { store } from '../../configureStore';
import { apiUrls } from '../../constants/apiUrl';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { setSession } from './Helpers';

const CallCradleAPI = (cradlePageName, currPageName) => {
  try {
    // 'plansOverview-signIn'/autopay-preview/lq_Change/FWA_PlansOverview

    const postData = {
      properties: [{ name: 'pageName', value: cradlePageName }],
    };
    const apiURL = `${getSecureBaseUrl()}${apiUrls().cradleApi}`;
    const apiResponse = HttpService.post(apiURL, postData);
    Promise.all([apiResponse]).then((res) => {
      if (res[0] && res[0].data && res[0].status === 200) {
        setSession('CradleResponse', 'Y');
        const throttleList = res?.[0]?.data?.throttleList || '';

        if (throttleList?.includes('|signInPlacement|')) {
          setSession('SignInPlansPage', 'Y');
        }

        if (throttleList?.includes('autopay-preview')) {
          setSession('autoPayPreview', 'Y');
        }

        if (throttleList?.includes('lq_Change')) {
          setSession('lqChange', 'Y');
        }

        if (currPageName === 'cart' && throttleList?.includes('FWA_Sweetener_T_Deal')) {
          setSession('sweetenerDeal', 'Y');
        } else if (currPageName === 'cart' && throttleList?.includes('FWA_Sweetener_C_Deal')) {
          setSession('sweetenerDeal', 'N');
        }

        store.dispatch({ type: 'SIGNIN_CRADLE_VALUE', response: throttleList });
        store.dispatch({ type: 'CRADLE_API_COMPLETED', response: true });
        store.dispatch({ type: 'STORE_CRADLE_THROTTLE_VALUE', response: throttleList });
      }
    });
  } catch (error) {
    // error block
  }
};
export default CallCradleAPI;
